<script lang="ts" setup>
  defineOptions({
    name: 'AppTextField',
    inheritAttrs: false
  });

  // useAttrs() must be obtained once, synchronously during setup, and read from
  // thereafter — computed getters can be lazily re-evaluated during an unrelated
  // reactivity flush (e.g. a Pinia store update elsewhere), where there's no
  // active component instance for useAttrs() to attach to, throwing otherwise.
  const attrs = useAttrs();

  // Generated once per component instance — see AppTextarea.vue for why computing
  // this suffix reactively inside the computed broke Vuetify's form (un)registration.
  const idSuffix = Math.random().toString(36).slice(2, 7);

  const elementId = computed(() => {
    const _elementIdToken = attrs.id || attrs.label;

    return _elementIdToken ? `app-text-field-${_elementIdToken}-${idSuffix}` : undefined;
  });

  const label = computed(() => attrs.label as string | undefined);
  const mandatory = computed(() => attrs.mandatory as boolean);
  const textFieldRef = ref();

  // TODO: HC - 1833
  // const combinedRules = computed(() => {
  //   const attrs = useAttrs();

  //   const externalRules = (attrs.rules as ((v: any) => true | string)[]) || [];

  //   return externalRules.length > 0 && typeof externalRules[0] === 'function'
  //     ? [minThreeAlphabetsValidator, ...externalRules]
  //     : externalRules;
  // });

  const formatValue = () => {
    const input = textFieldRef.value?.$el?.querySelector('input');
    if (input) {
      input.value = input.value
        ?.trim()
        .replace(/\s+/g, ' ')
        .replace(/^\w/, (c: string) => c.toUpperCase());

      input.dispatchEvent(new Event('input'));
    }
  };

  onMounted(() => {
    const input = textFieldRef.value?.$el?.querySelector('input');
    if (input) {
      input.addEventListener('change', formatValue);
    }
  });
</script>

<template>
  <div class="app-text-field flex-grow-1" :class="$attrs.class">
    <VLabel v-if="label" :for="elementId" class="mb-1 text-body-2 text-high-emphasis">
      {{ label }}
      <span v-if="mandatory" class="text-h6 text-error ms-1">*</span>
    </VLabel>
    <VTextField
      ref="textFieldRef"
      v-decimal-limit="2"
      v-allowed-text
      v-bind="{
        ...$attrs,
        class: null,
        label: undefined,
        variant: 'outlined',
        id: elementId
      }"
    >
      <!-- :rules="combinedRules" -->
      <template v-for="(_, name) in $slots" #[name]="slotProps">
        <slot :name="name" v-bind="slotProps || {}" />
      </template>
    </VTextField>
  </div>
</template>
